import React, { useEffect, useState } from "react";
import { Portal } from "react-portal";
import { useStores } from "_common/hooks";
import i18next from "i18next";

function ModalService({ open, onClose }) {
  const {
    authStore: { general },
  } = useStores();

  return (
    <Portal>
      <div
        className="modal modal-desktop"
        style={{ display: open ? "block" : "none" }}
      >
        <div className="mask" onClick={() => onClose()} />
        <div className="modal-content ">
          <div className="modal-header">
            <h2>{i18next.t("Service")}</h2>
            <div className="btn-close" onClick={() => onClose()}>
              X
            </div>
          </div>
          <div className="classic-bet-now">
            <div className="content">
              <div className="rules__content">
                <p>
                  The HNX Trader Global user agreement is the relevant rights
                  and obligations stipulated by the user and the HNX Trader
                  Global platform for various services, and is contractual.
                </p>
                <p>
                  By registering and using this website, the user means that he
                  accepts and agrees to all the conditions and terms of the
                  "User Agreement". Both HNX Trader Global and the user have
                  carefully read all the terms in this "User Agreement" and the
                  legal statements and operations issued by HNX Trader Global
                  The content of the rules, this agreement and the
                  aforementioned terms of service, legal statements and
                  operating rules have been known, understood and accepted, and
                  agreed to use them as the basis for determining the rights and
                  obligations of both parties.
                </p>
                <p>
                  The HNX Trader Global "legal statement" is an essential part
                  of this agreement. When the user accepts this agreement, it
                  shall be deemed to have accepted the entire content of the HNX
                  Trader Global "legal statement". The content of this agreement
                  includes the body of this agreement and the published or
                  Various rules, statements, and instructions that may be
                  released in the future. All rules, statements, and
                  instructions are an integral part of the agreement and have
                  the same legal effect as the body of the agreement.
                </p>
                <p>1. User service</p>
                <p>
                  1.1 HNX Trader Global provides online trading platform
                  services for users to conduct encrypted digital currency
                  transactions through the platform. HNX Trader Global does not
                  participate in the buying and selling of any digital currency
                  itself as a buyer or seller.
                </p>
                <p>
                  1.2 Users have the right to browse real-time digital currency
                  market quotations and transaction information on HNX Trader
                  Global, and have the right to submit digital currency
                  transaction instructions and complete digital currency
                  transactions through the HNX Trader Global platform.
                </p>
                <p>
                  1.3 Users have the right to view their information under the
                  platform member account in HNX Trader Global, and have the
                  right to use the functions provided by HNX Trader Global to
                  operate.
                </p>
                <p>
                  1.4 Users have the right to participate in website activities
                  organized by the platform in accordance with the activity
                  rules published by HNX Trader Global.
                </p>
                <p>
                  1.5 Users should abide by laws, regulations, regulatory
                  documents and policy requirements, ensure the legitimacy of
                  all funds and digital currency sources in the account, and
                  must not engage in illegal or other damage to the platform or
                  the third party in HNX Trader Global or use HNX Trader Global
                  services. The activities of tripartite rights, such as sending
                  or receiving any information that violates laws, regulations,
                  public order and good customs, or infringes on the rights and
                  interests of others, sending or receiving pyramid schemes or
                  other harmful information or speech, using or forging HNX
                  Trader Global electronics without the authorization of HNX
                  Trader Global Email header information, etc.
                </p>
                <p>
                  1.6 Users should abide by laws and regulations, and should
                  properly use and keep their HNX Trader Global platform account
                  and password, fund transaction password, mobile phone number
                  bound to the registration time, and the security of the mobile
                  phone verification code received by the mobile phone. The user
                  is fully responsible for any operations and consequences
                  performed using his platform account and password, capital
                  password, and mobile phone verification code. When the user
                  discovers that the HNX Trader Global platform account,
                  password or fund password, verification code is used by a
                  third party without its authorization, or there are other
                  account security issues, the HNX Trader Global platform will
                  be notified immediately and effectively, and the platform will
                  be required to suspend the service HNX Trader Global of the
                  platform account. The HNX Trader Global platform has the right
                  to take action on the user’s request within a reasonable time,
                  but it does not assume any responsibility for the losses that
                  the user has suffered before the HNX Trader Global platform
                  takes action. The user shall not give, borrow, rent, transfer
                  or otherwise dispose of the HNX Trader Global platform account
                  to others without the consent of the HNX Trader Global
                  platform.
                </p>
                <p>
                  1.7 The user shall abide by the user agreement and other terms
                  of service and operating rules published and updated by the
                  HNX Trader Global platform from time to time.
                </p>
                <p>Second, the rights and obligations of users</p>
                <p>
                  2.1 The user has the right to accept the digital currency
                  trading platform services provided by HNX Trader Global in
                  accordance with this agreement.
                </p>
                <p>
                  2.2 The user has the right to terminate the use of HNX Trader
                  Global platform services at any time.
                </p>
                <p>
                  2.3 Users have the right to withdraw the balance of funds in
                  HNX Trader Global at any time, but they need to pay the
                  corresponding withdrawal fees to the HNX Trader Global
                  platform.
                </p>
                <p>
                  2.4 The user is responsible for the authenticity, validity and
                  security of the personal information provided during
                  registration.
                </p>
                <p>
                  2.5 When users conduct digital currency transactions on the
                  HNX Trader Global platform, they must not maliciously
                  interfere with the normal conduct of digital currency
                  transactions and disrupt the order of transactions.
                </p>
                <p>
                  2.6 Users must not interfere with the normal operation of the
                  HNX Trader Global platform or interfere with other users' use
                  of the HNX Trader Global platform services by any technical
                  means or other means.
                </p>
                <p>
                  2.7 If users have litigation with other users due to online
                  transactions, they must not request the HNX Trader Global
                  platform to provide relevant data through judicial or
                  administrative channels.
                </p>
                <p>
                  2.8 Users shall not maliciously slander the reputation of the
                  HNX Trader Global platform by fabricating facts or other
                  means.
                </p>
                <p>
                  Third, the rights and obligations of the HNX Trader Global
                  platform
                </p>
                <p>
                  3.1 If the user does not have the registration qualifications
                  stipulated in this agreement, the HNX Trader Global platform
                  has the right to refuse the user to register, and the
                  registered user has the right to cancel his HNX Trader Global
                  platform member account. The HNX Trader Global platform
                  suffers losses due to this. The right to claim compensation
                  from the aforementioned users or their legal representatives.
                  At the same time, the HNX Trader Global platform reserves the
                  right to decide whether to accept user registration under any
                  other circumstances.
                </p>
                <p>
                  When the HNX Trader Global platform finds that the account
                  user is not the initial registrant of the account, it has the
                  right to suspend the use of the account.
                </p>
                <p>
                  3.2 When the HNX Trader Global platform reasonably suspects
                  that the information provided by the user is incorrect, false,
                  invalid or incomplete through technical testing, manual
                  sampling and other testing methods, it has the right to notify
                  the user to correct, update the information or suspend, and
                  terminate the provision of the HNX Trader Global platform.
                  service.
                </p>
                <p>
                  3.3 The HNX Trader Global platform has the right to correct
                  any information displayed on the HNX Trader Global platform
                  when there are obvious errors.
                </p>
                <p>
                  The platform reserves the right to modify, suspend or
                  terminate the HNX Trader Global platform services at any time.
                  The HNX Trader Global platform exercises the right to modify
                  or suspend the services without prior notice to the user. If
                  the HNX Trader Global platform terminates one or more services
                  of the HNX Trader Global platform, The termination will take
                  effect on the day when the HNX Trader Global platform
                  publishes the termination announcement on the website.
                </p>
                <p>
                  3.4 The HNX Trader Global platform shall adopt necessary
                  technical means and management measures to ensure the normal
                  operation of the HNX Trader Global platform, and provide
                  necessary and reliable trading environment and transaction
                  services to maintain the order of digital currency
                  transactions.
                </p>
                <p>
                  3.5 If the user has not used the HNX Trader Global platform
                  member account and password to log in to the HNX Trader Global
                  platform for three consecutive years, the HNX Trader Global
                  platform has the right to cancel the user's HNX Trader Global
                  platform account. After the account is cancelled, the HNX
                  Trader Global platform has the right to open the corresponding
                  member name to other users for registration.
                </p>
                <p>
                  3.7 The HNX Trader Global platform guarantees the safety of
                  users' RMB funds and digital currency custody by strengthening
                  technical investment and improving security precautions. It is
                  obliged to notify users in advance when there are foreseeable
                  security risks in user funds.
                </p>
                <p>
                  3.8 The HNX Trader Global platform has the right to delete all
                  kinds of content and information on the HNX Trader Global
                  platform website that do not comply with national laws and
                  regulations, regulatory documents or reports stipulated by the
                  HNX Trader Global platform website. The HNX Trader Global
                  platform does not need to notify in advance to exercise this
                  right user.
                </p>
                <p>Four, special statement</p>
                <p>
                  To the extent permitted by law, under any circumstances, the
                  HNX Trader Global platform is protected against maintenance of
                  information network equipment, information network connection
                  failures, computer, communications or other system failures,
                  power failures, strikes, labor disputes, riots, and uprisings.
                  , Riots, insufficient productivity or production data, fires,
                  floods, storms, explosions, wars, government actions, orders
                  from judicial administrative organs, other force majeure or
                  third-party inactions caused by inability to service or
                  delayed services, and users suffered as a result The loss is
                  not liable.
                </p>
                <p>Five, customer service</p>
                <p>
                  The HNX Trader Global platform has established a professional
                  customer service team and established a complete customer
                  service system to ensure the smooth flow of user questions and
                  complaint channels in terms of technology, personnel and
                  systems, and provide users with timely troubleshooting and
                  complaint feedback.
                </p>
                <p>Six, intellectual property</p>
                <p>
                  6.1 All intellectual achievements contained in the HNX Trader
                  Global platform include but are not limited to website logos,
                  databases, website design, text and graphics, software,
                  photos, videos, music, sounds and the foregoing combinations,
                  software compilation, related source codes and software
                  applications The intellectual property rights of programs and
                  scripts are owned by the HNX Trader Global platform. Users
                  shall not copy, change, copy, send or use any of the
                  aforementioned materials or content for commercial purposes.
                </p>
                <p>
                  6.2 All rights (including but not limited to goodwill and
                  trademarks, logos) contained in the name of the HNX Trader
                  Global platform belong to the HNX Trader Global platform.
                </p>
                <p>
                  6.3 The user's acceptance of this agreement shall be deemed as
                  the user's initiative to have the copyright of any form of
                  information published on the HNX Trader Global platform,
                  including but not limited to: reproduction rights,
                  distribution rights, rental rights, exhibition rights,
                  performance rights, projection rights, broadcasting rights
                  Rights, information network communication rights, filming
                  rights, adaptation rights, translation rights, compilation
                  rights and other transferable rights attributable to the
                  copyright owner are exclusively transferred to the HNX Trader
                  Global platform for free, and the HNX Trader Global platform
                  has the right to infringe on any subject Individually file a
                  lawsuit and obtain full compensation. This agreement is a
                  written agreement stipulated in Article 25 of the "United
                  Nations Copyright Law", and its validity is applicable to the
                  content of any copyright law-protected works published by
                  users on the HNX Trader Global platform, regardless of the
                  formation of the content Before signing this agreement or
                  after signing this agreement.
                </p>
                <p>
                  6.4 Users shall not illegally use the HNX Trader Global
                  platform or the intellectual property rights of others when
                  using the HNX Trader Global platform services.
                </p>
                <p>Seven, privacy policy</p>
                <p>
                  7.1 When a user registers an HNX Trader Global platform
                  account or payment account, the user provides personal
                  registration information according to the requirements of the
                  HNX Trader Global platform, including but not limited to
                  identity card information.
                </p>
                <p>
                  7.2 When the user uses the HNX Trader Global platform service
                  or visits the HNX Trader Global platform webpage, the HNX
                  Trader Global platform automatically receives and records the
                  server value on the user’s browser, including but not limited
                  to data such as IP address and user requirements for access
                  Web records of.
                </p>
                <p>
                  7.3 Relevant data collected by the HNX Trader Global platform
                  of users' transactions on the HNX Trader Global platform,
                  including but not limited to records of bids and purchases.
                </p>
                <p>
                  7.4 The personal information of other users obtained by the
                  HNX Trader Global platform through legal means.
                </p>
                <p>
                  7.5 The HNX Trader Global platform will not sell or lend the
                  user's personal information to anyone unless the user's
                  permission is obtained in advance. The HNX Trader Global
                  platform does not allow any third party to collect, edit, sell
                  or disseminate the user's personal information by any means.
                </p>
                <p>
                  7.6 The HNX Trader Global platform keeps the obtained customer
                  identity data and transaction information confidential, and
                  must not provide customer identity data and transaction
                  information to any unit or individual, unless otherwise
                  provided by laws and regulations.
                </p>
                <p>Eight, anti-money laundering</p>
                <p>
                  8.1 The HNX Trader Global platform complies with and
                  implements the provisions of the "Anti-Money Laundering Law of
                  the People's Republic of China" to identify users, maintain a
                  system for customer identity data and transaction history
                  records, as well as a system for large and suspicious
                  transaction reports.
                </p>
                <p>
                  8.2 When users register and modify their real-name
                  information, they should provide and upload necessary evidence
                  such as a copy of their ID card. The HNX Trader Global
                  platform will identify and compare the ID card information
                  provided by the user. The HNX Trader Global platform has
                  reasonable grounds to suspect that when a user registers with
                  a false identity, it has the right to refuse to register or
                  cancel the registered account.
                </p>
                <p>
                  8.3 The HNX Trader Global platform refers to the provisions of
                  the “Measures for the Administration of Large-Value
                  Transactions and Suspicious Transaction Reports of Financial
                  Institutions” to keep historical records of large-value
                  transactions and transactions suspected of money laundering.
                  When regulatory agencies require records of large-value
                  transactions and suspicious transactions, Provide to
                  regulatory agencies.
                </p>
                <p>
                  8.4 The HNX Trader Global platform saves user identity
                  information, large-value transactions, and historical records
                  of suspicious transactions, assists in accordance with the
                  law, cooperates with judicial and administrative law
                  enforcement agencies in combating money laundering activities,
                  and assists judicial agencies, customs, taxation and other
                  departments to inquire in accordance with laws and regulations
                  , Freezing and deducting customer deposits.
                </p>
                <p>
                  8.5 According to the national anti-money laundering policy and
                  the protection of customer assets, the name of the remitter
                  must be the same as the real-name certified name.
                </p>
                <p>Nine. Liability for breach of contract</p>
                <p>
                  9.1 The violation of the HNX Trader Global platform or the
                  user of this agreement constitutes a breach of contract, and
                  the breaching party shall be liable for breach of contract to
                  the observant party.
                </p>
                <p>
                  9.2 If the HNX Trader Global platform causes losses to the HNX
                  Trader Global platform due to untrue, incomplete or inaccurate
                  information provided by the user, the HNX Trader Global
                  platform has the right to request the user to compensate the
                  HNX Trader Global platform for losses.
                </p>
                <p>
                  9.3 If a user engages in illegal activities on the HNX Trader
                  Global platform or using the HNX Trader Global platform
                  services due to violation of laws and regulations or the
                  provisions of this agreement, the HNX Trader Global platform
                  has the right to immediately terminate the continued provision
                  of HNX Trader Global platform services to them, and cancel
                  them Account and demand compensation for the losses caused to
                  the HNX Trader Global platform.
                </p>
                <p>
                  9.4 If User interferes with the operation of HNX Trader Global
                  Platform by technical means or interferes with the use of HNX
                  Trader Global Platform by other Users, HNX Trader Global shall
                  have the right to immediately cancel the account of the User
                  on HNX Trader Global Platform and claim compensation for the
                  losses caused to HNX Trader Global.
                </p>
                <p>
                  9.5 If users maliciously slander the reputation of the HNX
                  Trader Global platform by fabricating facts, etc., the HNX
                  Trader Global platform has the right to request the user to
                  publicly apologize to the HNX Trader Global platform,
                  compensate for the losses caused to the HNX Trader Global
                  platform, and have the right to terminate it Provide HNX
                  Trader Global platform services.
                </p>
                <p>Ten. Entry into force and interpretation of the agreement</p>
                <p>
                  This agreement takes effect when the user clicks on the HNX
                  Trader Global platform registration page to agree to register
                  and complete the registration process, and obtains the HNX
                  Trader Global platform account and password, and is binding on
                  the HNX Trader Global platform and users.
                </p>
                <p>Eleven. Modification and termination of the agreement</p>
                <p>
                  11.1 Changes to the agreement: the HNX Trader Global platform
                  has the right to change the content of this agreement or other
                  terms of service and operating rules published by the HNX
                  Trader Global platform at any time. When the change is made,
                  the HNX Trader Global platform will publish an announcement in
                  a prominent place on the HNX Trader Global platform. , The
                  change takes effect when the announcement is released. If the
                  user continues to use the services provided by the HNX Trader
                  Global platform, it is deemed that the user agrees to the
                  content changes. If the user does not agree with the content
                  after the change, the user has the right to cancel the HNX
                  Trader Global platform account and stop Use HNX Trader Global
                  platform services.
                </p>
                <p>11.2 Termination of the agreement</p>
                <p>
                  11.2.1 The HNX Trader Global platform has the right to cancel
                  the user's HNX Trader Global platform account in accordance
                  with this agreement, and this agreement terminates on the date
                  of account cancellation.
                </p>
                <p>
                  11.2.2 The HNX Trader Global platform has the right to
                  terminate all HNX Trader Global platform services in
                  accordance with this agreement, and this agreement terminates
                  on the day when all HNX Trader Global platform services are
                  terminated.
                </p>
                <p>
                  11.2.3 After the termination of this agreement, the user has
                  no right to require the HNX Trader Global platform to continue
                  to provide it with any services or perform any other
                  obligations, including but not limited to requiring the HNX
                  Trader Global platform to retain or disclose its original HNX
                  Trader Global platform to the user Any information in the
                  account, forward any information that has not been read or
                  sent to the user or a third party.
                </p>
                <p>
                  11.2.4 The termination of this agreement does not affect the
                  observant party to the breaching party to pursue liability for
                  breach of contract.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
}

export default ModalService;
